import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo } from "react";
import { getDomain } from "@shared/blocks/helpers";
import { formatPhoneticForCard } from "./dictionary-api-hints";
import "./view.scss";
const MISSING_DEFINITION_PLACEHOLDER = "Definition unavailable.";
function stopCardEvent(e) {
    e.stopPropagation();
}
function getFaviconUrl(domain) {
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=32`;
}
function providerProfile(provider) {
    switch (provider) {
        case "merriam_webster":
            return { badge: "MW", modifierClass: "provider-merriam_webster" };
        case "cambridge":
            return { badge: "CA", modifierClass: "provider-cambridge" };
        case "oxford":
            return { badge: "OX", modifierClass: "provider-oxford" };
        case "dictionary_com":
            return { badge: "DC", modifierClass: "provider-dictionary_com" };
        default:
            return { badge: "DI", modifierClass: "provider-unknown" };
    }
}
export const DictionaryCardContent = memo(({ provider, headword, definition, partOfSpeech, phonetic, sourceUrl }) => {
    const profile = providerProfile(provider);
    const faviconUrl = useMemo(() => {
        const sourceDomain = getDomain(sourceUrl);
        return sourceDomain ? getFaviconUrl(sourceDomain) : undefined;
    }, [sourceUrl]);
    const pos = partOfSpeech?.trim();
    const phoneRaw = phonetic?.trim();
    const phone = phoneRaw ? formatPhoneticForCard(phoneRaw) : "";
    const def = definition.trim();
    const definitionText = def || MISSING_DEFINITION_PLACEHOLDER;
    const hw = headword.trim() || "Dictionary";
    const metaParts = [];
    if (pos) {
        metaParts.push(_jsx("span", { className: "dictionary-content__pos", children: pos }, "pos"));
    }
    if (phone.length > 0) {
        if (metaParts.length > 0) {
            metaParts.push(_jsxs("span", { "aria-hidden": "true", children: [" ", "|", " "] }, "sep"));
        }
        metaParts.push(_jsx("span", { children: phone }, "phone"));
    }
    const headerInner = faviconUrl ? (_jsx("img", { className: "dictionary-content__favicon", src: faviconUrl, alt: "", width: 22, height: 22 })) : (_jsx("span", { className: "dictionary-content__brand-mark", "aria-hidden": "true", children: profile.badge }));
    return (_jsxs("div", { className: `dictionary-content ${profile.modifierClass}`, children: [_jsx("div", { className: "dictionary-content__header", children: sourceUrl ? (_jsx("a", { href: sourceUrl, target: "_blank", rel: "noopener noreferrer", className: "dictionary-content__header-link", onClick: stopCardEvent, onMouseDown: stopCardEvent, children: headerInner })) : (headerInner) }), _jsxs("div", { className: "dictionary-content__body", children: [_jsx("div", { className: "dictionary-content__headword", children: hw }), metaParts.length > 0 ? _jsx("div", { className: "dictionary-content__meta", children: metaParts }) : null, _jsx("div", { className: "dictionary-content__definition", children: definitionText })] })] }));
});
